document.querySelectorAll('.gallery-tile-related-link').forEach((gallery) => {
	gallery.querySelectorAll('a').forEach((anchor) => {
		anchor.setAttribute('rel', 'noopener noreferrer');
		anchor.setAttribute('target', '_blank');
	});
});
